import { hasCapability, type User } from "../base";

export const taskAssignee = {
  update: (user: User) => hasCapability(user, "taskAssignee.update"),
};
